module.exports = __webpack_public_path__ + "assets/img/4.1c137af1.png";